var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM6.83594 8.12891L8.67578 9.96484L6.83594 11.8359C6.47266 12.2031 6.47266 12.7969 6.83594 13.1289C7.20312 13.5273 7.79688 13.5273 8.12891 13.1289L9.96484 11.3242L11.8359 13.1289C12.2031 13.5273 12.7969 13.5273 13.1289 13.1289C13.5273 12.7969 13.5273 12.2031 13.1289 11.8359L11.3242 9.96484L13.1289 8.12891C13.5273 7.79688 13.5273 7.20312 13.1289 6.83594C12.7969 6.47266 12.2031 6.47266 11.8359 6.83594L9.96484 8.67578L8.12891 6.83594C7.79688 6.47266 7.20312 6.47266 6.83594 6.83594C6.47266 7.20312 6.47266 7.79688 6.83594 8.12891Z",
    fill: "#E74A3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.9dffa3c548a425b2581fb25922c3c0aa.svg";
export { ForwardRef as ReactComponent };